import WallCommon from "./wallCommon";
import {Shower} from "../../parts/shower";

export default class SplitWall extends WallCommon {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'split_wall';
    this.partName = 'Split Wall';
    this.translateId = "visualizer.bathroom.walls.split_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
    // this.hasAdditionalParts = true;
    // this.additionalPartPartId = "split_wall_crop";
  }

  handleClick() {
    const showerParent = this.getParent().getParent().layout.parts[Shower.id];
    if (showerParent && showerParent.showerScreen) {
      showerParent.showerScreen.disabled = true;
    }
    super.handleClick();
  }

  // setLayers(layout) { // we can't enable it since nothing will be selected on the very first load
  //   const wallParent = layout.parts[Shower.id];
  //   if (wallParent && wallParent.showerScreen && !wallParent.showerScreen.disabled) {
  //     super.hideLayers();
  //     return;
  //   }
  //   return super.setLayers(layout);
  // }

}

